import React, { useState } from "react";
import { colors } from "../../../themes/Colors";

const TabButtonFlatButton = ({
  width,
  title,
  backgroundColor,
  textColor,
  onClick,
  selected,
}) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      onClick={onClick}
      style={{
        width: width ? width : 130,
        height: 40,
        borderTopRightRadius: 8,
        borderTopLeftRadius: 8,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: hover ? colors.white : backgroundColor,
        transition: "all 0.3s",
        cursor: "pointer",
        overflow: "visible",
        // WebkitBoxShadow: hover
        //   ? "-5px 5px 15px -1px #00000070"
        //   : "0px 0px 0px 0px #00000070",
      }}
    >
      <div
        style={{
          fontSize: 12,
          //   marginLeft: 5,
          fontWeight: "bold",
          color: hover ? colors.greenDark : textColor,
          textAlign: "center",
        }}
      >
        {title}
      </div>
    </div>
  );
};

export default TabButtonFlatButton;
